import type {
  AnalyticsEnvironment,
  CollectionMetadata,
  XViewPerfSdkMode,
} from "./types";

declare const __XVIEW_PERF_VERSION__: string;

export const XVIEW_PERF_VERSION =
  typeof __XVIEW_PERF_VERSION__ !== "undefined"
    ? __XVIEW_PERF_VERSION__
    : "dev";

export function collectionMetadata(
  mode: XViewPerfSdkMode,
  env?: AnalyticsEnvironment,
): CollectionMetadata {
  return {
    sdk_mode: mode,
    xview_perf_version: XVIEW_PERF_VERSION,
    analytics_env:
      env === "alpha" || env === "production" || env === "dev"
        ? env
        : "unknown",
  };
}
